// extracted by mini-css-extract-plugin
export default {"wrap":"oF-z","subtitle":"pF-z","contentWrap":"qF-z","imgWrap":"rF-z","heading":"sF-z","copy":"tF-z"};